import { useState, useEffect } from 'react';

const useSessionCheck = (startTime, sessionDialogOpen, setSessionDialogOpen) => {
  const [timer, setTimer] = useState(startTime);

  useEffect(() => {
    const myInterval = setInterval(() => {
      setTimer((t) => (t > 0 ? t - 1 : 0));
    }, 1000);

    const resetTimer = () => {
      if (sessionDialogOpen) return;
      setTimer(startTime);
    };

    const handleLocalActivity = () => resetTimer();

    const handleStorage = (e) => {
      if (e.key === 'lastActivity') {
        resetTimer();
      }
      if (e.key === 'stayClicked') {
        setSessionDialogOpen(false);
        resetTimer();
      }
    };

    window.addEventListener('local-activity', handleLocalActivity);
    window.addEventListener('storage', handleStorage);

    return () => {
      clearInterval(myInterval);
      window.removeEventListener('local-activity', handleLocalActivity);
      window.removeEventListener('storage', handleStorage);
    };
  }, [startTime, sessionDialogOpen]);

  useEffect(() => {
    const broadcastActivity = () => {
      window.dispatchEvent(new Event('local-activity'));
      localStorage.setItem('lastActivity', Date.now().toString());
    };

    const events = ['mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
    events.forEach((e) => window.addEventListener(e, broadcastActivity));
    return () => {
      events.forEach((e) => window.removeEventListener(e, broadcastActivity));
    };
  }, []);

  return timer;
};

export default useSessionCheck;
